import { EditOutlined } from "@ant-design/icons";
import { Space, Table, Drawer, Button, Tag } from 'antd';
import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';


import timeSlotService from "../../../api/time.slot.service";
import { ADD_MODE, DEFAULT_MASTER_DRAWER_WIDTH, GREEN_TAG, RED_TAG } from '../../../utility/Constants';
import DrawableCloseIcon from "../../common/DrawableCloseIcon";
import TimeSlotEntry from "./TimeSlotEntry";
import CustomTableSearch from "../../common/CustomTableSearch";








const TimeSlotList = () => {

  const dispatch = useDispatch();
  const state = useSelector((state) => state.timeslot)
  const [filteredSearchList, setFilteredSearchList] = useState([]);

  const showTotal = (total, range) => `${range[0]}-${range[1]} of ${total} items`;
  const [page, setPage] = React.useState(1);


  const [visible, setVisible] = useState(false);
  const [timeSlotList, setTimeSlotList] = useState([]);
  const [timeSlotData, setTimeSlotData] = useState({
    time_slot_id: 0,
    programme_id: '',
    programme_group_id: '',
    start_time: '',
    end_time: '',
    time_slot: '',
    is_active: "Y",
    mode: ADD_MODE,
    morning_or_special_coaching: '',
    day_id: ""
  });

  const showDrawer = (rowdata) => {

    //   setProgrammeCommercialData(_);

    setTimeSlotData({
      time_slot_id: rowdata.time_slot_id,
      programme_id: rowdata.programme_id,
      programme_group_id: rowdata.programme_group_id,
      start_time: rowdata.start_time,
      end_time: rowdata.end_time,
      time_slot: rowdata.time_slot,
      is_active: rowdata.is_active,
      morning_or_special_coaching: rowdata.morning_or_special_coaching,
      day_id: rowdata.day_id == 0 ? "" : rowdata.day_id,
      mode: "EDIT"
    })

    setVisible(true);

  };

  const onClose = () => {
    setVisible(false);
  };


  const columns = [
    {
      title: '#',
      dataIndex: 'index',
      render: (text, record, index) => (page - 1) * 10 + ++index,
      width: '5%',
    },
    {
      title: 'Programme',
      dataIndex: 'programme_name',
      key: 'programme_name',
      sorter: (a, b) => a.programme_name.localeCompare(b.programme_name),
    },
    {
      title: 'Programme Group',
      dataIndex: 'programme_group',
      key: 'programme_group',
      sorter: (a, b) => a.programme_group.localeCompare(b.programme_group),
    },
    {
      title: 'Morning/Special Coaching',
      dataIndex: 'morning_or_special_coaching',
      key: 'morning_or_special_coaching',
      sorter: (a, b) => (a.morning_or_special_coaching ?? '').localeCompare(b.morning_or_special_coaching ?? ''),
      render: (selectedObj, record) => (
        <Space size="middle">
          {
            record.morning_or_special_coaching == "TAPM" ? <><Tag>Adult Coaching</Tag></> : <></>
          }
          {
            record.morning_or_special_coaching == "TAPSC" ? <><Tag>Special Coaching</Tag></> : <></>
          }
        </Space>
      )
    },

    {
      title: 'Day',
      dataIndex: 'day_name',
      key: 'day_name',
      //sorter: (a, b) => a.programme_group.localeCompare(b.programme_group),
    },


    // {
    //   title: 'Start Time',
    //   dataIndex: 'start_time',
    //   key: 'start_time',
    //   sorter: (a, b) => a.start_time.localeCompare(b.start_time),
    // },
    // {
    //   title: 'End Time',
    //   dataIndex: 'end_time',
    //   key: 'end_time',
    //   sorter: (a, b) => a.end_time.localeCompare(b.end_time),
    // },
    {
      title: 'Time Slot',
      dataIndex: 'time_slot',
      key: 'time_slot',
      //sorter: (a, b) => a.time_slot.localeCompare(b.time_slot),
    },
    {
      title: 'Active',
      dataIndex: 'is_active',
      key: 'is_active',
      render: (selectedObj, record) => (
        <Space size="middle">
          {
            record.is_active == "Y" ? <><Tag color={GREEN_TAG}>Active</Tag></> : <><Tag color={RED_TAG}>Not Active</Tag></>
          }
        </Space>
      )
    },

    {
      title: 'Action',
      key: 'action',
      render: (selectedObj) => (

        <Space size="middle">
          {/* <a onClick={()=> showDrawer(selectedObj)}>Edit {selectedObj.component_id}</a> */}
          <Button htmlType="button" type="ghost" size="small" shape="round" onClick={() => showDrawer(selectedObj)}>Edit <EditOutlined /></Button>
        </Space>
      ),
    },
  ];

  const getUpdatedList = (originalList) =>{
    return originalList.map((data) => {
      let obj = {};
      columns.map((cur_col) => {
        if (cur_col.key && cur_col.key !== undefined && cur_col.key !== 'action') {
          obj[cur_col.key] = data[cur_col.key];
        }
      });
      return obj;
    })
  }


  useEffect(() => {
    timeSlotService.list().then((res) => {

      //previous code
      // setTimeSlotList(res.data.response_data);
      // setFilteredSearchList(res.data.response_data);

      // modified  - 5/4/24
      const updatedList = getUpdatedList(res.data.response_data);
      setTimeSlotList(updatedList);
      setFilteredSearchList(updatedList);
    });
  }, [state.timeslot])

  // const isDisplayed = (data) =>{
  //   columns.map((cur)=>{

  //   })
  // }


  const onSearch = (e) => {
    setFilteredSearchList([]);
    const string = e.target.value;
    const filtered_list = timeSlotList.filter((data) => JSON.stringify(data).toLowerCase().indexOf(string.toLowerCase()) !== -1);
    setFilteredSearchList(filtered_list)
  }

  return (
    <>
      <CustomTableSearch onSearchTable={onSearch} />
      <Table
        columns={columns}
        rowKey='time_slot_id'
        dataSource={filteredSearchList}
        pagination={{
          showTotal,
          onChange(current) {
            setPage(current);
          }
        }}
        size="small"
      />

      <Drawer
        title="Edit time slot"
        width={DEFAULT_MASTER_DRAWER_WIDTH}
        onClose={onClose}
        visible={visible}
        bodyStyle={{
          paddingBottom: 80,
        }}
        destroyOnClose={true}
        closeIcon={<><DrawableCloseIcon /></>}
      >
        <TimeSlotEntry data={timeSlotData} onDrawerClose={onClose} />
      </Drawer>

    </>
  );
};

export default TimeSlotList;